import { PageValidationFunctions } from '../types';
import { applicantDetails } from '../Rsp/applicantDetails';
import { applicationFinancialYear } from '../Rsp/applicationFinancialYear';
import { contractedRnDServicesCapability } from '../Rsp/contractedRnDServicesCapability';
import { declarationsAndAcknowledgement } from '../Rsp/declarationsAndAcknowledgement';
import { scheduleOfResearchFields } from '../Rsp/scheduleOfResearchFields';

export const RspRegistration: PageValidationFunctions = {
    applicationFinancialYear,
    applicantDetails,
    contractedRnDServicesCapability,
    declarationsAndAcknowledgement,
    scheduleOfResearchFields,
};
